import axios from '../api/BaseURL'
import authHeader from './auth-header'

class customerAPI {
  // service_type type create
  createCustomer(data) {
    return axios.put('/customer/registration', data, { headers: authHeader() })
  }

  // list
  getList() {
    return axios.get('/customer/list', { headers: authHeader() })
  }
  // profile details
  getProfileDetails() {
    return axios.get('/customer/profile-details', { headers: authHeader() })
  }

  // service_type type delete
  deleteCustomer(id) {
    return axios.delete('/customer/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    })
  }

  // change status
  changeStatus(id) {
    return axios.post(
      '/customer/changeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    )
  }

  // service_type type update
  updateCustomer(data) {
    return axios.put('/customer/registration', data, {
      headers: authHeader(),
    })
  }

  // service list
  getServiceList(data) {
    return axios.post('/customer-service/assignServiceList', data, {
      headers: authHeader(),
    })
  }

  // update service price
  updateServicePrice(data) {
    return axios.put('/customer-service/priceUpdate', data, {
      headers: authHeader(),
    })
  }

  // get details
  getDetails(id) {
    return axios.get('/customer/details/' + id, { headers: authHeader() })
  }

  // customer invoice
  invoiceList(data) {
    return axios.post('/customer/customer-invoice-records', data, {
      headers: authHeader(),
    })
  }
  // customer invoice => own
  invoiceListOwn() {
    return axios.get('/customer/customer-own-invoice-records', {
      headers: authHeader(),
    })
  }

  // account record own
  accountRecordOwn() {
    return axios.get('/customer/customer-own-account-records', {
      headers: authHeader(),
    })
  }
  // service assign
  serviceAssign(data) {
    return axios.put('/customer-service/assignService', data, {
      headers: authHeader(),
    })
  }

  // already assigned service list
  alreadyAssignedServices(id) {
    return axios.get('/customer-service/listOfAssignedServices/' + id, {
      headers: authHeader(),
    })
  }
}
export default new customerAPI()
